import { render, staticRenderFns } from "./InspectionFormReminderFormModal.vue?vue&type=template&id=bdd90656"
import script from "./InspectionFormReminderFormModal.vue?vue&type=script&lang=js"
export * from "./InspectionFormReminderFormModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports